import React from 'react'

import styled from 'styled-components'

const StyledButtons = styled.div`
  display: flex;
  justify-content: flex-start;
  margin: 2rem 0;
  flex-wrap: wrap;
  row-gap: 1rem;
  column-gap: 1rem;

  @media screen and (max-width: ${(p) => p.theme.sizes.tablet}) {
    flex-direction: column;
    align-items: center;
  }
`

const StyledButtonsList = ({ children, ...props }) => {
  return <StyledButtons {...props}>{children}</StyledButtons>
}

export default StyledButtonsList
